var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logout"},[_c('el-card',[_c('h2',[_vm._v("已退出登陆")]),_c('p',[_vm._v(_vm._s(_vm.time)+" 秒后自动返回首页")]),_c('div',[_c('router-link',{attrs:{"to":"/"}},[_c('el-button',[_vm._v("返回首页")])],1)],1),_c('p',[_vm._v("感谢您的访问!")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }